export default {
    company: {},
    loggedin: {
        status: false,
        profile: {},
        checkin: false,
    },
    pusher: null,
    slug: 'users',
    title: 'Users',
    visible: [
        'master_user.profile_image',
        'master_user.first_name',
        'master_user.last_name',
        'master_user.email',
        'role'
    ],
    listview: 'UserListView',
    locales: ['common'],
    templates: {},
    columns: [],
    actions: {
        user_grid_view: {
            title: 'To grid view',
            level: 'global',
            icon: 'fal fa-th',
            vm: 'goToGridView'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/users/state.js